import React, { useState } from "react";

export default function NumberGuessing() {
  const [target, setTarget] = useState(Math.floor(Math.random() * 100) + 1);
  const [guess, setGuess] = useState("");
  const [message, setMessage] = useState("Guess a number between 1 and 100!");
  const [attempts, setAttempts] = useState(0);
  const [won, setWon] = useState(false);

  const handleGuess = (e) => {
    e.preventDefault();
    if (won || !guess) return;
    const num = parseInt(guess);
    setAttempts((a) => a + 1);

    if (num === target) {
      setMessage(`🎉 Correct! You got it in ${attempts + 1} tries!`);
      setWon(true);
    } else if (num < target) setMessage("📉 Too low! Try higher.");
    else setMessage("📈 Too high! Try lower.");

    setGuess("");
  };

  return (
    <div className="min-h-screen bg-slate-900 flex flex-col items-center justify-center font-sans text-white">
      <div className="bg-slate-800 p-8 rounded-2xl shadow-xl max-w-sm w-full text-center">
        <h1 className="text-2xl font-bold mb-6">Number Guesser</h1>
        <p
          className={`text-lg mb-6 font-semibold ${won ? "text-green-400" : "text-blue-400"}`}
        >
          {message}
        </p>

        {!won ? (
          <form onSubmit={handleGuess} className="flex flex-col gap-4">
            <input
              type="number"
              value={guess}
              onChange={(e) => setGuess(e.target.value)}
              className="px-4 py-3 bg-slate-700 rounded-xl text-center text-xl outline-none focus:ring-2 focus:ring-indigo-500"
              placeholder="Enter number..."
              autoFocus
            />
            <button
              type="submit"
              className="py-3 bg-indigo-600 rounded-xl font-bold hover:bg-indigo-700 transition"
            >
              Guess
            </button>
          </form>
        ) : (
          <button
            onClick={() => {
              setTarget(Math.floor(Math.random() * 100) + 1);
              setWon(false);
              setAttempts(0);
              setMessage("Guess a number between 1 and 100!");
            }}
            className="w-full py-3 bg-green-600 rounded-xl font-bold hover:bg-green-700 transition"
          >
            Play Again
          </button>
        )}
      </div>
    </div>
  );
}
